/* eslint-disable no-fallthrough */
/* eslint-disable react/jsx-curly-newline */
import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { FaTrash } from 'react-icons/fa';
import swal from 'sweetalert2';
import { showPhoneNumber } from '../../utils/masks';
import useCondominiumDwellerActions from '../../hooks/useCondominiumDwellerActions';
import DwellerPermissionReasonModal from '../DwellerPermissionReasonModal';

function DwellerItem({ dweller, onCompleted, submitOnChange }) {
  const { answerRequest, changePermission } = useCondominiumDwellerActions({
    dweller,
    onCompleted,
  });
  const [isReasonModalOpened, setReasonModalOpened] = useState(false);
  const [permission, setPermission] = useState();
  const setInitialPermission = () => {
    const { permissions } = dweller.unity;
    if (!permissions) return;
    if (permissions.vote) setPermission('vote');
    else if (permissions.comment) setPermission('comment');
    else setPermission('view');
  };

  useEffect(() => {
    setInitialPermission();
  }, [dweller]);

  const handleAction = async accepted => answerRequest({ accepted, permission });

  const handleChange = e => {
    const newPermission = e.target.value;
    setPermission(newPermission);

    if (!submitOnChange) return;

    const hasDowngradeToViewOnly = permission !== newPermission && newPermission === 'view';

    if (hasDowngradeToViewOnly) {
      setReasonModalOpened(true);
      return;
    }

    changePermission({ permission: newPermission });
  };

  const handleCloseModal = () => {
    setReasonModalOpened(false);
    setInitialPermission();
  };

  const handleDelete = async () => {
    // handleAction(false)
    const { value } = await swal.fire({
      icon: 'warning',
      title: 'Você tem certeza?',
      text: 'O usuário não poderá mais visualizar as assembleias do condomínio',
      confirmButtonText: 'Remover!',
      confirmButtonColor: '#ad2929',
      showCancelButton: true,
    });
    if (value) handleAction(false);
  };

  const handleDowngrade = ({ type, description }) => {
    setReasonModalOpened(false);
    changePermission({ permission, reason: { type, description } });
  };

  return (
    <>
      {isReasonModalOpened && (
        <DwellerPermissionReasonModal handleClose={handleCloseModal} dweller={dweller} onSubmit={handleDowngrade} />
      )}
      <div className="d-flex flex-col justify-content-between align-items-center mt-3 border-bottom p-2">
        <div className="d-flex flex-column">
          <p className="mb-0 ">{`${dweller.name} - ${dweller.unity && dweller.unity.name}`}</p>
          <small>{showPhoneNumber(dweller.phoneNumber)}</small>
          <div className="form-group mt-2">
            <select className="form-control form-control-sm" onChange={handleChange} value={permission}>
              <option value="vote">Pode votar e comentar</option>
              {/* <option value="comment">Pode comentar</option> */}
              <option value="view">Pode apenas visualizar</option>
            </select>
          </div>
        </div>
        <div className="d-flex flex-column justify-content-between align-items-center">
          {dweller.unity.status === 'pending' && (
            <>
              <button
                className="btn btn-success btn-sm text-white btn-block"
                type="button"
                onClick={() => handleAction(true)}
              >
                aceitar
              </button>
              <button
                className="btn btn-warning btn-sm text-white btn-block"
                type="button"
                onClick={() => handleAction(false)}
              >
                recusar
              </button>
            </>
          )}
          {dweller.unity.status === 'approved' && (
            <button
              className="btn btn-clear text-danger d-flex align-items-center"
              type="button"
              onClick={() => handleDelete()}
            >
              <FaTrash />
            </button>
          )}
        </div>
      </div>
    </>
  );
}

DwellerItem.propTypes = {
  dweller: propTypes.object.isRequired,
  onCompleted: propTypes.func,
  submitOnChange: propTypes.bool,
};

DwellerItem.defaultProps = {
  onCompleted: () => {},
  submitOnChange: false,
};

export default DwellerItem;
